<template>

  <textarea
    class="form-control"
    style="height: 250px"
    :value="value"
    @input="change"></textarea>

</template>

<script>
export default {
  name: 'TextareaCode',
  components: {
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    change (val) {
      this.$emit('input', val.target.value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/TextareaCode.vue